import { useContext } from 'react';
import { BreakPointsContext } from '@/providers/BreakPointsProvider';
import { useMediaQuery, useTheme } from '@mui/material';

export const useBreakPoints = () => {
  const { isMobile: deviceIsMobile } = useContext(BreakPointsContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), {
    defaultMatches: deviceIsMobile,
  });
  const isUnderTabletSize = useMediaQuery(theme.breakpoints.down(1000), {
    defaultMatches: true,
  });

  return { isMobile, isUnderTabletSize };
};
